import { render } from "./VODUploadWidgetLight.vue?vue&type=template&id=34626212&scoped=true"
import script from "./VODUploadWidgetLight.vue?vue&type=script&lang=js"
export * from "./VODUploadWidgetLight.vue?vue&type=script&lang=js"

import "./VODUploadWidgetLight.vue?vue&type=style&index=0&id=34626212&scoped=true&lang=css"
import "./VODUploadWidgetLight.vue?vue&type=style&index=1&id=34626212&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34626212"]])

export default __exports__